import Layout from '@/layout'

export const dsp = [
  {
    path: '/dsp/advertising',
    component: Layout,
    redirect: '/dsp/advertising/agent',
    alwaysShow: true,
    name: 'Advertising',
    meta: {
      title: '广告投放',
      permission_uri: '/dsp/advertising',
      icon: 'advertising'
    },
    children: [{
      path: 'media-account',
      name: 'AdvertisingMediaAccount',
      component: () => import('@/views/dsp/advertising/mediaAccount'),
      meta: {
        title: '媒体账户',
        icon: 'media',
        permission_uri: '/dsp/advertising/media-account'
      }
    }, {
      path: 'majordomo-account',
      name: 'AdvertisingMajordomoAccount',
      component: () => import('@/views/dsp/advertising/majordomoAccount'),
      meta: {
        title: '管家账户',
        icon: 'majordomo',
        permission_uri: '/dsp/advertising/majordomo-account'
      }
    }, {
      path: 'wechat-app',
      name: 'AdvertisingWechatApp',
      component: () => import('@/views/dsp/advertising/wechatApp'),
      meta: {
        title: '微信账户',
        icon: 'wechat',
        permission_uri: '/dsp/advertising/wechat-app'
      }
    }, {
      path: 'sh-report-config',
      name: 'ShReportConfig',
      component: () => import('@/views/dsp/advertising/shReportConfig.vue'),
      meta: {
        title: '自定义回传配置',
        icon: 'majordomo',
        permission_uri: '/dsp/advertising/sh-report-config'
      }
    }, {
      path: 'agent',
      name: 'AdvertisingAgent',
      component: () => import('@/views/dsp/advertising/agent'),
      meta: {
        title: '渠道管理',
        permission_uri: '/dsp/advertising/agent',
        icon: 'agent'
      }
    },
    {
      path: 'agent-group',
      name: 'AdvertisingAgentGroup',
      component: () => import('@/views/dsp/advertising/agentGroup'),
      meta: {
        title: '渠道组管理',
        permission_uri: '/dsp/advertising/agent-group',
        icon: 'agent-group'
      }
    },
    {
      path: 'media-channel-agent',
      name: 'AdvertisingMediaChannelAgent',
      component: () => import('@/views/dsp/advertising/mediaChannelAgent'),
      meta: {
        title: '渠道包管理',
        permission_uri: '/dsp/advertising/media-channel-agent',
        icon: 'sdk'
      }
    },
    {
      path: 'ldy',
      name: 'AdvertisingLDY',
      component: () => import('@/views/dsp/advertising/ldy'),
      meta: {
        title: '落地页管理',
        permission_uri: '/dsp/advertising/ldy',
        icon: 'ldy'
      }
    },
    {
      path: 'site',
      name: 'AdvertisingSite',
      component: () => import('@/views/dsp/advertising/site'),
      meta: {
        title: '广告配置管理',
        permission_uri: '/dsp/advertising/site',
        icon: 'site'
      }
    },
    {
      path: 'sdk',
      name: 'AdvertisingSDK',
      component: () => import('@/views/dsp/advertising/sdk'),
      meta: {
        title: 'SDK管理',
        permission_uri: '/dsp/advertising/sdk',
        icon: 'sdk'
      }
    },
    {
      path: 'live-user',
      name: 'AdvertisingLiveUser',
      component: () => import('@/views/dsp/advertising/liveUser'),
      meta: {
        title: '直播账号管理',
        permission_uri: '/dsp/advertising/live-user',
        icon: 'rule'
      }
    },
    {
      path: 'live-user-interface',
      name: 'AdvertisingLiveUserInterfacePerson',
      component: () => import('@/views/dsp/advertising/liveUserInterfacePerson'),
      meta: {
        title: '直播对接关系管理',
        permission_uri: '/dsp/advertising/live-user-interface',
        icon: 'game-relation'
      }
    },
    {
      path: 'aweme-account-interface',
      name: 'AdvertisingAwemeAccountInterface',
      component: () => import('@/views/dsp/advertising/awemeAccountInterface'),
      meta: {
        title: '达人账号对接管理',
        permission_uri: '/dsp/advertising/aweme-account-interface',
        icon: 'aweme-interface'
      }
    },
    {
      path: 'site-log',
      name: 'AdvertisingSiteLog',
      component: () => import('@/views/dsp/advertising/siteLog'),
      meta: {
        title: '广告切换',
        permission_uri: '/dsp/advertising/site-log',
        icon: 'switch'
      }
    },
    {
      path: 'apk',
      name: 'AdvertisingAPK',
      component: () => import('@/views/dsp/advertising/apk'),
      meta: {
        title: 'APK列表',
        permission_uri: '/dsp/advertising/apk',
        icon: 'apk'
      }
    },
    {
      path: 'record',
      name: 'AdvertisingRecord',
      component: () => import('@/views/dsp/advertising/record'),
      meta: {
        title: '操作记录',
        permission_uri: '/dsp/advertising/record',
        icon: 'log'
      }
    },
    {
      path: 'majordomo-todo',
      name: 'MajordomoTodo',
      component: () => import('@/views/dsp/advertising/majordomoTodo'),
      meta: {
        title: '待办事项',
        permission_uri: '/dsp/advertising/majordomo-todo',
        icon: 'todo'
      }
    },
    {
      path: 'media-game-callback-strategy',
      name: 'AdvertisingMediaGameCallbackStrategy',
      component: () => import('@/views/dsp/advertising/mediaGameCallbackStrategy'),
      meta: {
        title: '媒体上报策略管理',
        permission_uri: '/dsp/advertising/media-game-callback-strategy',
        icon: 'agent-group'
      }
    },
    {
      path: 'landing-page-apps',
      name: 'AdvertisingLandingPageApps',
      component: () => import('@/views/dsp/advertising/landingPageApps'),
      meta: {
        title: '落地页多应用配置',
        permission_uri: '/dsp/advertising/landing-page-apps',
        icon: 'el-icon-setting',
        elementuiIcon: true
      }
    }]
  },
  {
    path: '/dsp/game-manage',
    component: Layout,
    redirect: '/dsp/game-manage/game-icon',
    name: 'DSPGameManage',
    alwaysShow: true,
    meta: {
      title: '游戏管理',
      icon: 'game-manage',
      permission_uri: '/dsp/game-manage'
    },
    children: [{
      path: 'game-relation',
      name: 'AdvertisingGameRelation',
      component: () => import('@/views/dsp/advertising/gameRelation'),
      meta: {
        title: '游戏关系',
        permission_uri: '/dsp/game-manage/game-relation',
        icon: 'game-relation'
      }
    }, {
      path: 'game-icon',
      name: 'GameIcon',
      component: () => import('@/views/dsp/gameManage/gameIcon'),
      meta: {
        title: 'icon管理',
        icon: 'game-icon',
        permission_uri: '/dsp/game-manage/game-icon'
      }
    }, {
      path: 'game',
      name: 'Game',
      component: () => import('@/views/dsp/gameManage/game'),
      meta: {
        title: '游戏出包',
        icon: 'game',
        permission_uri: '/dsp/game-manage/game'
      }
    }, {
      path: 'game-callback-strategy',
      name: 'GameManageGameCallbackStrategy',
      component: () => import('@/views/dsp/gameManage/gameCallbackStrategy'),
      meta: {
        title: '游戏扣量配置',
        permission_uri: '/dsp/game-manage/game-callback-strategy',
        icon: 'el-icon-setting',
        elementuiIcon: true
      }
    }]
  },
  {
    path: '/dsp/material',
    component: Layout,
    alwaysShow: true,
    name: 'Material',
    meta: {
      title: '素材管理',
      icon: 'material',
      permission_uri: '/dsp/material'
    },
    children: [{
      path: 'store',
      name: 'MaterialStore',
      component: () => import('@/views/dsp/material/store'),
      meta: {
        title: '素材库',
        permission_uri: '/dsp/material/store',
        icon: 'store'
      }
    }, {
      path: 'file',
      name: 'MaterialFile',
      component: () => import('@/views/dsp/material/file'),
      hidden: true,
      meta: {
        title: '素材文件列表',
        permission_uri: '/dsp/material/store',
        icon: 'file'
      }
    }, {
      path: 'add',
      name: 'MaterialAdd',
      component: () => import('@/views/dsp/material/add'),
      meta: {
        title: '创建素材',
        permission_uri: '/dsp/material/add',
        icon: 'add-material'
      }
    }, {
      path: 'add-custom-group-material',
      name: 'MaterialAddCustomGroup',
      component: () => import('@/views/dsp/material/addCustomGroupMaterial'),
      meta: {
        title: '创建组图素材',
        permission_uri: '/dsp/material/add-custom-group-material',
        icon: 'add-material'
      }
    }, {
      path: 'theme',
      name: 'MaterialTheme',
      component: () => import('@/views/dsp/material/theme'),
      meta: {
        title: '题材管理',
        permission_uri: '/dsp/material/theme',
        icon: 'label'
      }
    }, {
      path: 'mode',
      name: 'MaterialMode',
      component: () => import('@/views/dsp/material/mode'),
      meta: {
        title: '尺寸管理',
        permission_uri: '/dsp/material/mode',
        icon: 'size'
      }
    }, {
      path: 'effect',
      name: 'MaterialEffect',
      component: () => import('@/views/dsp/material/effect'),
      meta: {
        title: '素材效果',
        permission_uri: '/dsp/material/effect',
        icon: 'dashboard'
      }
    }, {
      path: 'share-rule',
      name: 'ShareRule',
      component: () => import('@/views/dsp/material/shareRule'),
      meta: {
        title: '共享规则',
        permission_uri: '/dsp/material/share-rule',
        icon: 'rule'
      }
    }, {
      path: 'task',
      name: 'MaterialTask',
      component: () => import('@/views/dsp/material/materialTask'),
      meta: {
        title: '素材上传任务',
        permission_uri: '/dsp/material/task',
        icon: 'task'
      }
    }, {
      path: 'expand-task',
      name: 'MaterialExpandTask',
      component: () => import('@/views/dsp/material/materialExpandTask'),
      meta: {
        title: '素材扩展任务',
        permission_uri: '/dsp/material/expand-task',
        icon: 'expand'
      }
    }, {
      path: 'material_combination',
      name: 'MaterialCombination',
      component: () => import('@/views/dsp/material/materialCombination'),
      meta: {
        title: '素材组合功能',
        permission_uri: '/dsp/material/combination',
        icon: 'expand'
      }
    }, {
      path: 'ai_material_route',
      name: 'AiMaterialRoute',
      component: () => import('@/views/dsp/material/aiMaterialRoute'),
      meta: {
        title: 'AI-工具导航',
        permission_uri: '/dsp/material/ai-material-route',
        icon: 'expand'
      }
    }, {
      path: 'score-rule',
      name: 'MaterialScoreRule',
      component: () => import('@/views/dsp/material/scoreRule'),
      meta: {
        title: '评分规则',
        permission_uri: '/dsp/material/score-rule',
        icon: 'score'
      }
    }, {
      path: 'author-effect',
      name: 'MateriaAuthorlEffect',
      component: () => import('@/views/dsp/material/authorEffect'),
      meta: {
        title: '绩效统计',
        permission_uri: '/dsp/material/author-effect',
        icon: 'dashboard'
      }
    }, {
      path: 'mark-rule',
      name: 'MaterialMarkRule',
      component: () => import('@/views/dsp/material/markRule'),
      meta: {
        title: '标记规则',
        permission_uri: '/dsp/material/mark-rule',
        icon: 'marker'
      }
    }, {
      path: 'label',
      name: 'MaterialLabel',
      component: () => import('@/views/dsp/material/label'),
      meta: {
        title: '标签管理',
        permission_uri: '/dsp/material/label',
        icon: 'label'
      }
    }, {
      path: 'expert',
      name: 'MaterialExpert',
      component: () => import('@/views/dsp/material/expert'),
      meta: {
        title: '达人管理',
        permission_uri: '/dsp/material/expert',
        icon: 'user'
      }
    }, {
      path: 'platformMaterialSync',
      name: 'PlatformMaterialSync',
      component: () => import('@/views/dsp/material/platformSyncMaterialTask'),
      meta: {
        title: '平台素材同步',
        permission_uri: '/dsp/material/platformMaterialSync',
        icon: 'material'
      }
    }, {
      path: 'image-ai',
      name: 'ImageAi',
      component: () => import('@/views/dsp/material/imageAi.vue'),
      meta: {
        title: '图片AI',
        permission_uri: '/dsp/material/image-ai',
        icon: 'material'
      }
    }]
  },
  {
    path: '/dsp/ad-create',
    component: Layout,
    redirect: '/dsp/ad-create/account-packet',
    alwaysShow: true,
    name: 'ADCreate',
    meta: {
      permission_uri: '/dsp/ad-create',
      title: '广告批量创建',
      icon: 'site'
    },
    children: [{
      path: 'account-packet',
      name: 'AccountPacket',
      component: () => import('@/views/dsp/batchAD/accountPacket'),
      meta: {
        permission_uri: '/dsp/ad-create/account',
        title: '账号包管理',
        icon: 'user'
      }
    },
    {
      path: 'targeting',
      name: 'TargetingPacket',
      component: () => import('@/views/dsp/batchAD/targetingPacket'),
      meta: {
        permission_uri: '/dsp/ad-create/targeting',
        title: '定向包管理',
        icon: 'target'
      }
    }, {
      path: 'word',
      name: 'WordPacket',
      component: () => import('@/views/dsp/batchAD/wordPacket'),
      meta: {
        permission_uri: '/dsp/ad-create/word',
        title: '文案包管理',
        icon: 'word'
      }
    }, {
      path: 'tag',
      name: 'TagPacket',
      component: () => import('@/views/dsp/batchAD/tagPacket'),
      meta: {
        permission_uri: '/dsp/ad-create/tag',
        title: '标签包管理',
        icon: 'label'
      }
    }, {
      path: 'material',
      name: 'MaterialPacket',
      component: () => import('@/views/dsp/batchAD/materialPacket'),
      meta: {
        permission_uri: '/dsp/ad-create/material',
        title: '素材包管理',
        icon: 'material'
      }
    }, {
      path: 'setting',
      name: 'SettingPacket',
      component: () => import('@/views/dsp/batchAD/settingPacket'),
      meta: {
        permission_uri: '/dsp/ad-create/setting',
        title: '参数包管理',
        icon: 'setting'
      }
    }, {
      path: 'compose',
      name: 'BatchADCompose',
      component: () => import('@/views/dsp/batchAD/compose'),
      meta: {
        permission_uri: '/dsp/ad-create/compose',
        title: '广告组合',
        icon: 'compose'
      }
    }, {
      path: 'task',
      name: 'BatchADTask',
      component: () => import('@/views/dsp/batchAD/task'),
      meta: {
        permission_uri: '/dsp/ad-create/task',
        title: '广告任务',
        icon: 'task'
      }
    }, {
      path: 'intelligent-compose',
      name: 'IntelligentCompose',
      component: () => import('@/views/dsp/batchAD/intelligentComposeView'),
      meta: {
        permission_uri: '/dsp/ad-create/intelligent-compose',
        title: '智创组合',
        icon: 'ai-creative'
      }
    },
    {
      path: 'intelligent-monitor-exec-body',
      name: 'IntelligentMonitorExecBody',
      component: () => import('@/views/dsp/batchAD/IntelligentMonitorExecBody'),
      meta: {
        permission_uri: '/dsp/ad-create/intelligent-monitor-exec-body',
        title: '智创监控执行体',
        icon: 'model'
      }
    },
    {
      path: 'intelligent-monitor-robot',
      name: 'IntelligentMonitorRobot',
      component: () => import('@/views/dsp/batchAD/IntelligentMonitorRobot'),
      meta: {
        permission_uri: '/dsp/ad-create/intelligent-monitor-robot',
        title: '智创监控机器人',
        icon: 'robot'
      }
    }, {
      path: 'add-compose',
      name: 'AddCompose',
      hidden: true,
      component: () => import('@/views/dsp/batchAD/addCompose'),
      meta: {
        title: '新建广告组合',
        icon: 'compose'
      }
    }, {
      path: 'task-log',
      name: 'BatchADTaskLog',
      component: () => import('@/views/dsp/batchAD/taskLog'),
      meta: {
        permission_uri: '/dsp/ad-create/task-log',
        title: '广告任务日志',
        icon: 'log'
      }
    }, {
      path: 'task-solution',
      name: 'BatchADTaskSolution',
      component: () => import('@/views/dsp/batchAD/taskSolution'),
      meta: {
        permission_uri: '/dsp/ad-create/task-solution',
        title: '错误信息管理',
        icon: 'marker'
      }
    }]
  },
  {
    path: '/dsp/ad-asset',
    component: Layout,
    redirect: '/dsp/ad-asset/tencent-wechat-profile',
    alwaysShow: true,
    name: 'ADAsset',
    meta: {
      permission_uri: '/dsp/ad-asset',
      title: '广告资产管理',
      icon: 'asset-admin'
    },
    children: [{
      path: 'tencent-wechat-profile',
      name: 'TencentWechatprofile',
      component: () => import('@/views/dsp/adAsset/TencentWechatProfile'),
      meta: {
        permission_uri: '/dsp/ad-asset/tencent-wechat-profile',
        title: '腾讯朋友圈头像',
        icon: 'add-material'
      }
    }, {
      path: 'baidu-campaign-create-log',
      name: 'BaiduCampaignCreateLog',
      component: () => import('@/views/dsp/adAsset/BaiduCampaignCreateLog'),
      meta: {
        permission_uri: '/dsp/ad-asset/baidu-campaign-create-log',
        title: '百度推广计划记录',
        icon: 'baidu'
      }
    }, {
      path: 'toutiao-orange-station-push',
      name: 'ToutiaoOrangeStationPush',
      component: () => import('@/views/dsp/adAsset/ToutiaoOrangeStationPush'),
      meta: {
        permission_uri: '/dsp/ad-asset/toutiao-orange-station-push',
        title: '头条橙子建站',
        icon: 'site'
      }
    }, {
      path: 'toutiao-bird-clue-profile',
      name: 'ToutiaoBirdClueProfile',
      component: () => import('@/views/dsp/adAsset/ToutiaoBirdClueProfile'),
      meta: {
        permission_uri: '/dsp/ad-asset/toutiao-bird-clue-profile',
        title: '头条青鸟线索',
        icon: 'clue'
      }
    }, {
      path: 'toutiao-native-anchor',
      name: 'ToutiaoNativeAnchor',
      component: () => import('@/views/dsp/adAsset/ToutiaoNativeAnchor'),
      meta: {
        permission_uri: '/dsp/ad-asset/toutiao-native-anchor',
        title: '头条原生锚点',
        icon: 'clue'
      }
    }, {
      path: 'toutiao-avatar',
      name: 'ToutiaoAvatar',
      component: () => import('@/views/dsp/adAsset/ToutiaoAvatar'),
      meta: {
        permission_uri: '/dsp/ad-asset/toutiao-avatar',
        title: '头条广告主头像',
        icon: 'material'
      }
    },
    {
      path: 'toutiao-star-live-anchor',
      name: 'ToutiaoLiveAnchor',
      component: () => import('@/views/dsp/adAsset/ToutiaoStarLiveAnchor'),
      meta: {
        permission_uri: '/dsp/ad-asset/toutiao-star-live-anchor',
        title: '星图主播管理',
        icon: 'marker'
      }
    },
    {
      path: 'toutiao-star-component',
      name: 'ToutiaoStarComponent',
      component: () => import('@/views/dsp/adAsset/ToutiaoStarComponent'),
      meta: {
        permission_uri: '/dsp/ad-asset/toutiao-star-component',
        title: '头条星图组件',
        icon: 'size'
      }
    }, {
      path: 'toutiao-star-compose-list',
      name: 'ToutiaoStarComposeList',
      component: () => import('@/views/dsp/adAsset/ToutiaoStarComposeList'),
      meta: {
        permission_uri: '/dsp/ad-asset/toutiao-star-compose-list',
        title: '星图需求发布',
        icon: 'compose'
      }
    }, {
      path: 'toutiao-star-add-compose',
      name: 'ToutiaoStarAddCompose',
      hidden: true,
      component: () => import('@/views/dsp/adAsset/ToutiaoStarAddCompose'),
      meta: {
        title: '新建星图需求组合',
        icon: 'compose'
      }
    },
    {
      path: 'toutiao-star-task-list',
      name: 'ToutiaoStarTaskList',
      component: () => import('@/views/dsp/adAsset/ToutiaoStarTaskList'),
      meta: {
        permission_uri: '/dsp/ad-asset/toutiao-star-task-list',
        title: '星图需求任务',
        icon: 'task'
      }
    },
    {
      path: 'toutiao-star-video-list',
      name: 'ToutiaoStarVideoList',
      component: () => import('@/views/dsp/adAsset/ToutiaoStarVideoList'),
      meta: {
        permission_uri: '/dsp/ad-asset/toutiao-star-video-list',
        title: '星图资源确认',
        icon: 'task'
      }
    },
    {
      path: 'toutiao-star-aweme',
      name: 'ToutiaoAweme',
      component: () => import('@/views/dsp/adAsset/ToutiaoStarAweme'),
      meta: {
        permission_uri: '/dsp/ad-asset/toutiao-star-aweme',
        title: '星图达人管理',
        icon: 'marker'
      }
    }]
  },
  {
    path: '/dsp/channel-promotion',
    component: Layout,
    redirect: '/dsp/channel-promotion/video-manage',
    alwaysShow: true,
    name: 'ChannelPromotion',
    meta: {
      title: '加热视频号智投',
      icon: 'ai',
      permission_uri: '/dsp/channel-promotion'
    },
    children: [
      {
        path: 'video-manage',
        name: 'VideoManage',
        component: () => import('@/views/dsp/channelPromotion/videoManage'),
        meta: {
          title: '视频管理',
          permission_uri: '/dsp/channel-promotion/video-manage',
          icon: 'rule'
        }
      },
      {
        path: 'order-manage',
        name: 'OrderManage',
        component: () => import('@/views/dsp/channelPromotion/orderManage'),
        meta: {
          title: '订单管理',
          permission_uri: '/dsp/channel-promotion/order-manage',
          icon: 'rule'
        }
      },
      {
        path: 'add-channel-order',
        name: 'ChannelPromotionOrderAdd',
        hidden: true,
        component: () => import('@/views/dsp/channelPromotion/compents/ChannelPromotionOrderAdd'),
        meta: {
          title: '新建订单',
          icon: 'compose'
        }
      }
    ]
  },
  {
    path: '/dsp/ad-lab',
    component: Layout,
    redirect: '/dsp/ad-lab/group',
    alwaysShow: true,
    name: 'ADLab',
    meta: {
      title: '智投实验室',
      icon: 'ai',
      permission_uri: '/dsp/ad-lab'
    },
    children: [{
      path: 'group',
      name: 'Lab',
      component: () => import('@/views/dsp/adLab/lab'),
      meta: {
        title: '智投项目',
        permission_uri: '/dsp/ad-lab/group',
        icon: 'rule'
      }
    },
    {
      path: 'operation-log',
      name: 'OperationLog',
      component: () => import('@/views/dsp/adLab/operationLog'),
      meta: {
        title: '智投操作日志',
        permission_uri: '/dsp/ad-lab/operation-log',
        icon: 'log'
      }
    }]
  },
  {
    path: '/dsp/adanalysis',
    component: Layout,
    redirect: '/dsp/adanalysis/report',
    alwaysShow: true,
    name: 'Adanalysis',
    meta: {
      title: '数据分析',
      icon: 'el-icon-data-analysis',
      permission_uri: '/dsp/adanalysis',
      elementuiIcon: true
    },
    children: [{
      path: 'report',
      name: 'AdAnalysisReport',
      component: () => import('@/views/dsp/adanalysis/report'),
      meta: {
        title: '基本报表',
        permission_uri: '/dsp/adanalysis/report',
        icon: 'log'
      }
    }, {
      path: 'live-report',
      name: 'AdAnalysisLiveReport',
      component: () => import('@/views/dsp/adanalysis/liveReport'),
      meta: {
        title: '星图短视频分析',
        permission_uri: '/dsp/adanalysis/live-report',
        icon: 'media'
      }
    }, {
      path: 'live-audio-report',
      name: 'AdAnalysisLiveAudioReport',
      component: () => import('@/views/dsp/adanalysis/liveAudioReport'),
      meta: {
        title: '星图直播分析',
        permission_uri: '/dsp/adanalysis/live-audio-report',
        icon: 'media'
      }
    }, {
      path: 'live-cost-report',
      name: 'AdAnalysisLiveCostReport',
      component: () => import('@/views/dsp/adanalysis/liveCostReport/index'),
      meta: {
        title: '直播成本',
        permission_uri: '/dsp/adanalysis/live-cost-report',
        icon: 'media'
      }
    }, {
      path: 'live-audio-report-detail',
      name: 'AdAnalysisLiveAudioReportDetail',
      hidden: true,
      component: () => import('@/views/dsp/adanalysis/liveAudioReportDetail'),
      meta: {
        title: '星图直播分析详情',
        icon: 'media'
      }
    }, {
      path: 'data-update-log',
      name: 'DataUpdateLog',
      component: () => import('@/views/dsp/adanalysis/dataUpdateLog'),
      meta: {
        title: '数据更新日志',
        // permission_uri: '/dsp/adanalysis/data-update-log',
        icon: 'data-update-log'
      }
    }]
  },
  {
    path: '/dsp/finance',
    component: Layout,
    redirect: '/dsp/finance/fund',
    alwaysShow: true,
    name: 'Finance',
    meta: {
      title: '财务对账',
      icon: 'finance',
      permission_uri: '/dsp/finance'
    },
    children: [{
      path: 'fund',
      name: 'FinanceFund',
      component: () => import('@/views/dsp/finance/fund'),
      meta: {
        title: '资金流水记录',
        permission_uri: '/dsp/finance/fund',
        icon: 'fund'
      }
    }, {
      path: 'report',
      name: 'FinanceReport',
      component: () => import('@/views/dsp/finance/report'),
      meta: {
        title: '财务对账报表',
        permission_uri: '/dsp/finance/report',
        icon: 'fund-check'
      }
    }, {
      path: 'screenshot-mission',
      name: 'ScreenshotMission',
      component: () => import('@/views/dsp/finance/screenshotMission'),
      meta: {
        title: '截图任务',
        permission_uri: '/dsp/finance/screenshot-mission',
        icon: 'screenshot'
      }
    }, {
      path: 'agency',
      name: 'FinanceAgency',
      component: () => import('@/views/dsp/finance/agency'),
      meta: {
        title: '代理信息变更',
        permission_uri: '/dsp/finance/agency',
        icon: 'log'
      }
    }, {
      path: 'transaction-check',
      name: 'TransactionCheck',
      component: () => import('@/views/dsp/finance/transactionCheck'),
      meta: {
        title: '转账校对',
        permission_uri: '/dsp/finance/transaction-check',
        icon: 'magnifier'
      }
    }, {
      path: 'return-goods-record',
      name: 'ReturnGoodsRecord',
      component: () => import('@/views/dsp/finance/returnGoodsRecord'),
      meta: {
        title: '返货记录',
        permission_uri: '/dsp/finance/return-goods-record',
        icon: 'fund-check'
      }
    }, {
      path: 'mail',
      name: 'Mail',
      component: () => import('@/views/dsp/finance/mail'),
      meta: {
        title: '邮件结算',
        permission_uri: '/dsp/finance/mail',
        icon: 'fund-check'
      }
    }, {
      path: 'account_center',
      name: 'AccountCenter',
      component: () => import('@/views/dsp/finance/accountCenter'),
      meta: {
        title: '台账中心',
        permission_uri: '/dsp/finance/account_center',
        icon: 'fund-check'
      }
    }, {
      path: 'permission',
      name: 'Permission',
      component: () => import('@/views/dsp/finance/permission'),
      meta: {
        title: '台账权限',
        permission_uri: '/dsp/finance/permission',
        icon: 'permission'
      }
    }]
  },
  {
    path: '/dsp/delivery',
    component: Layout,
    redirect: '/dsp/delivery/ios-monitor-rule',
    alwaysShow: true,
    name: 'Delivery',
    meta: {
      title: '智投规则管理',
      icon: 'intelligence',
      permission_uri: '/dsp/delivery'
    },
    children: [
      {
        path: 'ios-monitor-rule',
        name: 'IosMonitorRule',
        component: () => import('@/views/dsp/delivery/IosMonitorRule'),
        meta: {
          title: 'iOS监控规则',
          permission_uri: '/dsp/delivery/ios-monitor-rule',
          icon: 'rule'
        }
      },
      {
        path: 'ios-monitor-log',
        name: 'IosMonitorLog',
        component: () => import('@/views/dsp/delivery/IosMonitorLog'),
        meta: {
          title: 'iOS监控记录',
          permission_uri: '/dsp/delivery/ios-monitor-log',
          icon: 'log'
        }
      },
      {
        path: 'put-the-bid-rules',
        name: 'PutTheBidRules',
        component: () => import('@/views/dsp/delivery/putTheBidRules'),
        meta: {
          title: '投放出价范围规则',
          permission_uri: '/dsp/delivery/put-the-bid-rules',
          icon: 'rule'
        }
      },
      {
        path: 'ad-monitor-change',
        name: 'AdMonitorChange',
        component: () => import('@/views/dsp/delivery/adMonitorChange'),
        meta: {
          title: '一键启停计划',
          permission_uri: '/dsp/delivery/ad-monitor-change',
          icon: 'log'
        }
      },
      {
        path: 'auto-transfer-rule',
        name: 'AutoTransferRule',
        component: () => import('@/views/dsp/delivery/autoTransferRule'),
        meta: {
          title: '自动转账规则',
          permission_uri: '/dsp/delivery/auto-transfer-rule',
          icon: 'rule'
        }
      },
      {
        path: 'auto-transfer-log',
        name: 'AutoTransferLog',
        component: () => import('@/views/dsp/delivery/autoTransferLog'),
        meta: {
          title: '自动转账记录',
          permission_uri: '/dsp/delivery/auto-transfer-log',
          icon: 'log'
        }
      },
      {
        path: 'calc-monitor-rule',
        name: 'CalcMonitorRule',
        component: () => import('@/views/dsp/delivery/calcMonitorRule'),
        meta: {
          title: '数值监控规则',
          permission_uri: '/dsp/delivery/calc-monitor-rule',
          icon: 'rule'
        }
      },
      {
        path: 'calc-monitor-log',
        name: 'CalcMonitorLog',
        component: () => import('@/views/dsp/delivery/calcMonitorLog'),
        meta: {
          title: '数值监控记录',
          permission_uri: '/dsp/delivery/calc-monitor-log',
          icon: 'log'
        }
      },
      {
        path: 'leader-standard',
        name: 'LeaderStandard',
        component: () => import('@/views/dsp/delivery/leaderStandard'),
        meta: {
          title: '消耗预算标准',
          permission_uri: '/dsp/delivery/leader-standard',
          icon: 'el-icon-timer',
          elementuiIcon: true
        }
      },
      {
        path: 'standard-reference',
        name: 'StandardReference',
        component: () => import('@/views/dsp/delivery/standardReference'),
        meta: {
          title: '产品参考标准',
          permission_uri: '/dsp/delivery/standard-reference',
          icon: 'log'
        }
      },
      {
        path: 'sub-scription-service',
        name: 'SubscriptionService',
        component: () => import('@/views/dsp/delivery/subscriptionService'),
        meta: {
          title: '订阅服务',
          permission_uri: '/dsp/delivery/sub-scription-service',
          icon: 'sub-scription-service'
        }
      }]
  },
  {
    path: '/dsp/comment',
    component: Layout,
    redirect: '/dsp/comment/list',
    alwaysShow: true,
    name: 'Comment',
    meta: {
      title: '评论管理',
      icon: 'comment',
      permission_uri: '/dsp/comment'
    },
    children: [{
      path: 'list',
      name: 'CommentList',
      component: () => import('@/views/dsp/comment/list'),
      meta: {
        title: '评论列表',
        permission_uri: '/dsp/comment/list',
        icon: 'log'
      }
    }, {
      path: 'shielded-word',
      name: 'ShieldedWord',
      component: () => import('@/views/dsp/comment/shieldedWord'),
      meta: {
        title: '屏蔽词管理',
        permission_uri: '/dsp/comment/shielded-word',
        icon: 'rule'
      }
    }, {
      path: 'shielded-user',
      name: 'ShieldedUser',
      component: () => import('@/views/dsp/comment/shieldedUser'),
      meta: {
        title: '屏蔽用户管理',
        permission_uri: '/dsp/comment/shielded-user',
        icon: 'blacklist'
      }
    }, {
      path: 'operate-log',
      name: 'OperateLog',
      component: () => import('@/views/dsp/comment/operateLog'),
      meta: {
        title: '操作记录',
        permission_uri: '/dsp/comment/operate-log',
        icon: 'log'
      }
    }]
  },
  {
    path: '/dsp/rta',
    component: Layout,
    redirect: '/dsp/rta/list',
    alwaysShow: true,
    name: 'RTA',
    meta: {
      title: 'RTA管理',
      icon: 'lightning',
      permission_uri: '/dsp/rta'
    },
    children: [{
      path: 'user-group-model',
      name: 'UserGroupModel',
      component: () => import('@/views/dsp/rta/userGroupModel'),
      meta: {
        title: '用户分群模型',
        permission_uri: '/dsp/rta/user-group-model',
        icon: 'rule'
      }
    }, {
      path: 'stategy',
      name: 'Stategy',
      component: () => import('@/views/dsp/rta/stategy'),
      meta: {
        title: '策略管理',
        permission_uri: '/dsp/rta/stategy',
        icon: 'log'
      }
    }]
  },
  {
    path: '/dsp/permission',
    component: Layout,
    redirect: '/dsp/permission/member',
    name: 'DSPPermission',
    alwaysShow: true,
    meta: {
      title: '权限管理',
      icon: 'permission',
      permission_uri: '/dsp/permission'
    },
    children: [{
      path: 'member',
      name: 'DSPPermissionMember',
      component: () => import('@/views/dsp/permission/member'),
      meta: {
        title: '成员管理',
        icon: 'user',
        permission_uri: '/dsp/permission/member'
      }
    }]
  },
  {
    path: '/dsp/ad-monetization',
    component: Layout,
    redirect: '/dsp/ad-monetization/group',
    name: 'DSPAdMonetization',
    alwaysShow: true,
    meta: {
      title: '广告变现',
      icon: 'ad',
      permission_uri: '/dsp/ad-monetization'
    },
    children: [{
      path: 'group',
      name: 'DSPAdMonetizationGroup',
      component: () => import('@/views/dsp/adMonetization/group'),
      meta: {
        title: '流量组配置',
        icon: 'agent-group',
        permission_uri: '/dsp/ad-monetization/group'
      }
    },
    {
      path: 'plan',
      name: 'DSPAdMonetizationPlan',
      component: () => import('@/views/dsp/adMonetization/plan'),
      meta: {
        title: '计划配置',
        icon: 'site',
        permission_uri: '/dsp/ad-monetization/plan'
      }
    }]
  }
]
